module.exports = __webpack_public_path__ + "img/t_legis.1e42de3e.gif";